angular.module('unica_workshop_session.workshop_session_controllers', [])

.controller('WorkshopSessionBasicController',
	function(
		$rootScope, $scope, $stateParams
	) {

	$scope.forms = {};

	$scope.event_id = $stateParams.event_id;

	$rootScope.workshopSessionData = {
		workshop_id: $stateParams.workshop_id
	};

	$scope.parseWorkshopSessionFromDateToTimestamp = function(workshopSessionData) {
		var tmpDay = moment( workshopSessionData.day, "DD/MM/YYYY");
		workshopSessionData.from_date = moment( tmpDay ).format('YYYY-MM-DD');
		workshopSessionData.from_time = moment( workshopSessionData.from_time ).format('HH:mm:ss');
		workshopSessionData.to_date   = moment( tmpDay ).format('YYYY-MM-DD');
		workshopSessionData.to_time   = moment( workshopSessionData.to_time ).format('HH:mm:ss');
		return workshopSessionData;
	};

});


